<template>
    <el-watermark :font="font" :content="watermarkContent" z-index="9999">
        <el-config-provider :locale="lang">
            <router-view></router-view>
        </el-config-provider>
    </el-watermark>
</template>
<script setup lang="ts">
import { onMounted, watch, reactive, computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { useRoute } from 'vue-router'
import { useConfig } from '/@/stores/config'
import { setTitleFromRoute } from '/@/utils/common'
import iconfontInit from '/@/utils/iconfont'
import { init as viteInit } from '/@/utils/vite'
import { useAdminInfo } from '/@/stores/adminInfo'
// modules import mark, Please do not remove.

const route = useRoute()
const config = useConfig()

const adminInfo = useAdminInfo()
const font = reactive({
    color: 'rgba(0, 0, 0, .15)',
})
/**
 * 水印内容
 */
const watermarkContent = computed(() => {
    let result = ''
    if (adminInfo.token && route.path !== '/bigDataView' && route.path !== '/monitor') {
        result = adminInfo.nickname + '#' + adminInfo.id
    }
    return result
})
// 初始化 element 的语言包
const { getLocaleMessage } = useI18n()
const lang = getLocaleMessage(config.lang.defaultLang) as any
onMounted(() => {
    viteInit()
    iconfontInit()

    // Modules onMounted mark, Please do not remove.
})

// 监听路由变化时更新浏览器标题
watch(
    () => route.path,
    () => {
        setTitleFromRoute()
    }
)
</script>
